import { UserDetails } from '../types/schemas/abc';
import { getTimezoneOffset, adjustAvailabilityForTimezone, calculateOverlapMinutes } from './availability';

export const calculateExpertiseMatch = (parent: UserDetails, tutor: UserDetails): number => {
    const parentExpertise = parent.expertise || {};
    const tutorExpertise = tutor.expertise || {};
    const parentRequirements = Object.entries(parentExpertise).flatMap(([subject, levels]) =>
      levels.map(level => `${subject}:${level}`)
    );
    if (parentRequirements.length === 0) return 0;
    let matchedCount = 0;
    parentRequirements.forEach(requirement => {
      const [subject, level] = requirement.split(':');
      if (tutorExpertise[subject] && tutorExpertise[subject].includes(level)) {
        matchedCount++;
      }
    });
    return matchedCount;
  };

  export const calculateScheduleOverlap = (parent: UserDetails, tutor: UserDetails): number => {
    if (!parent.availability || !tutor.availability) return 0;
    const parentTz = parent.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const tutorTz = tutor.timezone || parentTz;
    const offset = getTimezoneOffset(parentTz, tutorTz);
    const adjusted = adjustAvailabilityForTimezone(tutor.availability, offset);
    return Math.round(calculateOverlapMinutes(parent.availability, adjusted) / 60);
  };